export default __webpack_public_path__ + "assets/front/scss/user-authentication.35c4f0a75c741c8e322442c20365cacb.css";